import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import Toggle from './Toggle';
import Pagination from './Pagination';
import Calendar from './Timeline/Calendar';
import MakeReadyBoardTable from './Table';
import MetricsContainer from './MetricsContainer';
import Utils from '../../Services/Utils';
import UnitsService from '../../Services/api/Units';
import WorkflowsInstancesService from '../../Services/api/WorkflowsInstancesService';
import Property from '../../Services/api/Property';
import Select from 'react-select';

import ConfigService from '../../Services/api/Config';
import { MrbContext, MrbContextProvider } from '../../Context/MrbContext';
import Spin from '../Common/Spin';
/**
 * Styles
 */
import './style.scss';


class MakeReadyBoard extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      flipToggle: false,
      range: [],
      page: 1,
      pageLimit: 50,
      data: [],
      dataTable: [],
      orderingElements: { ordering: '', sortOrder: 1 },
      day: moment(),
      count: 0,
      loading: true
    };
  }

  UNSAFE_componentWillMount() {
    const { configTheme } = this.props;
    ConfigService.updateConfig(configTheme);
  }

  componentDidMount() {
    const { filters, range, page, flipToggle } = this.props;

    const range1 = moment(range[0]);
    const range2 = moment(range[1]);

    if (!range[1]) {
      range2.add(13, 'day');
    }

    this.updateInitialRange(  this.changeFormat(range1), this.changeFormat(range2), flipToggle, filters);
 
    if(range[0]){
      this.setState({
        day: moment(range[0]),
      });
    }
    this.setState({
      page,
      flipToggle
    });
  }

  updateInitialRange = (rangeStart, rangeEnd, flipToggle, filters) => {
    const { orderingElements } = this.state;
    this.setState({
      range: [rangeStart, rangeEnd]
    });
    this.getData([rangeStart, rangeEnd], orderingElements, flipToggle);
    this.getMetricsData([rangeStart, rangeEnd], filters['property']);
  };

  componentDidUpdate(prevProps) {
    const { filters } = this.props;
    const { range, orderingElements, flipToggle } = this.state;

    if (!Utils.equals(prevProps.filters, filters)) {
      this.getData(range, orderingElements, flipToggle);

      this.getMetricsData(range, filters['property']);
    }
  }

  changeFormat = (d) => d.format('YYYY-MM-DD');


  getMetricsData = async (range, property) => {
    const filters = {};
    const rangeStart = !Utils.isEmpty(range) ? moment(range[0], "YYYY-MM-DD") : undefined;
    const rangeEnd = !Utils.isEmpty(range) ? moment(range[1], "YYYY-MM-DD") : undefined;
    filters['mrb_range_start'] = rangeStart.format('YYYY-MM-DD');
    filters['mrb_range_end'] = rangeEnd.format('YYYY-MM-DD');
    filters['page'] = this.state.page ? this.state.page : undefined;
    filters['limit'] = this.state.pageLimit ? this.state.pageLimit : undefined;

    const metricsData = await Property.getMetrics(property, filters);
    this.setState({
      metricsData
    });
  };

  getData = async (range, { ordering, sortOrder }, flipToggle) => {
    const { filters } = this.props;

    let dataTable = []
    let data = []

    const rangeStart = !Utils.isEmpty(range) ? moment(range[0], "YYYY-MM-DD") : undefined;
    const rangeEnd = !Utils.isEmpty(range) ? moment(range[1], "YYYY-MM-DD") : undefined;
    filters['mrb_range_start'] = rangeStart.format('YYYY-MM-DD');
    filters['mrb_range_end'] = rangeEnd.format('YYYY-MM-DD');
    filters['ordering'] = `${sortOrder == -1 ? "-" : ""}${ordering}`;
    filters['page'] = this.state.page ? this.state.page : undefined;
    filters['limit'] = this.state.pageLimit ? this.state.pageLimit : undefined;
    this.setState({
      loading: true
    });
    if (flipToggle) {
      dataTable = await WorkflowsInstancesService.getMakeReadyBoard(filters);
      this.setState({
        count: dataTable?.count,
        data: [],
        dataTable: dataTable?.results,
        orderingElements: { ordering, sortOrder },
        loading: false
      });
    } else {
      data = await UnitsService.getMakeReadyBoard(filters);
      this.setState({
        count: data?.count,
        data: data?.results,
        dataTable: [],
        orderingElements: { ordering, sortOrder },
        loading: false
      });
    }
  };

  toggleView = () => {
    const { range, page, flipToggle } = this.state;
    const { onTrigger } = this.props;
    onTrigger(range, page, !flipToggle)
    this.setState({
      flipToggle: !flipToggle
    });
  };

  handleAction = (action, task, moveInDate, actionItems) => {
    const { onAction } = this.props;
    onAction(action, task, moveInDate, actionItems);
  };

  updateRange = (rangeStart, rangeEnd) => {
    const { orderingElements, flipToggle } = this.state;
    const { filters } = this.props;
    this.setState({
      range: [rangeStart, rangeEnd]
    });
    this.getData([rangeStart, rangeEnd], orderingElements, flipToggle);
    this.getMetricsData([rangeStart, rangeEnd], filters['property']);
  };

  updateSort = (ordering, sortOrder) => {
    const { range, flipToggle } = this.state;

    this.getData(range, { ordering, sortOrder }, flipToggle);
  };

  handleDayChange = (value) => {
    this.setState({
      day: value
    });
    const rangeStart = this.changeFormat(value.clone());
    const rangeEnd = this.changeFormat(value.clone().add(13, 'day'));
    this.updateRange(rangeStart, rangeEnd);
  };

  updatePage = (page) => {
    const { range, orderingElements, flipToggle } = this.state;
    const { filters } = this.props;
    this.setState(
      {
        page
      },
      () => {
        this.getData(range, orderingElements, flipToggle);
        this.getMetricsData(range, filters['property']);
      }
    );
  };
  sortoptions = [
    {'label': 'Unit Number (High to Low)', 'value': 'number_desc', 'orderBy': 'number', 'orderType': 'desc'},
    {'label': 'Unit Number (Low to High)', 'value': 'number_asc', 'orderBy': 'number', 'orderType': 'asc'},
    {'label': 'Building (Z-A)', 'value': 'building_desc','orderBy': 'building', 'orderType': 'desc'},
    {'label': 'Building (A-Z)', 'value': 'building_asc', 'orderBy': 'building','orderType': 'asc'},
    {'label': 'Unit Type (Z-A)', 'value': 'unit_type_desc','orderBy': 'unit_type__name', 'orderType': 'desc'},
    {'label': 'Unit Type (A-Z)', 'value': 'unit_type_asc', 'orderBy': 'unit_type__name','orderType': 'asc'},
    {'label': 'Status (Z-A)', 'value': 'turn_status_desc', 'orderBy': 'turn_status','orderType': 'desc'},
    {'label': 'Status (A-Z)', 'value': 'turn_status_asc', 'orderBy': 'turn_status','orderType': 'asc'},
    {'label': 'Move In (Newest to Oldest)', 'value': 'next_move_in_date_desc', 'orderBy': 'next_move_in_date','orderType': 'desc'},
    {'label': 'Move In (Oldest to Newest)', 'value': 'next_move_in_date_asc', 'orderBy': 'next_move_in_date','orderType': 'asc'},
    {'label': 'Expected Completion date (Newest to Oldest)', 'value': 'expected_completion_date_desc', 'orderBy': 'expected_completion_date','orderType': 'desc'},
    {'label': 'Expected Completion date (Oldest to Newest)', 'value': 'expected_completion_date_asc', 'orderBy': 'expected_completion_date', 'orderType': 'asc'},
  ];

  handleChange = (e) => {
    const {onChange, value, multiple } = this.props;

    let newValue = e && e.target ? e.target.value : e
    if (!multiple) {
      const newValueFormatted = Utils.isObject(newValue) ? newValue.value.toString() : newValue;
      if (value == newValueFormatted) {
        newValue = {label:'', value:'', orderBy: '', orderType:''};
      }
    }
    else {
      if (value == newValue) {
        newValue = {label:'', value:'', orderBy: '', orderType:''};
      }
    }
    
    if (onChange) onChange(newValue);
    
    if (newValue.orderType === 'asc') {
      this.updateSort(newValue.orderBy, 1);
    } else {
      this.updateSort(newValue.orderBy, -1);
    }
  };

  isPermissionAvailable = (...permissions) => {
    const { hasPermission } = this.props;
    return hasPermission(permissions);
  }

  render() {
    const { day, flipToggle, data, dataTable, range, metricsData, count, loading } = this.state;
    let dataArr = (dataTable.length > 0 ? dataTable : []);
    return (
      <div className="MakeReadyBoard">
        <Suspense fallback={<div>Loading...</div>}>
          <MrbContextProvider data={data}>
            <div className="MakeReadyBoard__header">
              <div>
                <Toggle label={['Timeline', 'Table']} isOn={flipToggle} handleToggle={this.toggleView} />
                {!flipToggle && (
                <div className="dropdown">
                  <Select 
                  options={ this.sortoptions }
                  onChange={ this.handleChange }
                  placeholder={ 'Sort By' } />
                </div>
                )}
              </div>
              <div className="MakeReadyBoard__header-counters">
                <MetricsContainer metricsData={metricsData} />
              </div>
            </div>
            {flipToggle ? (
              <MakeReadyBoardTable data={dataArr} updateSort={this.updateSort} />
            ) : (
              <div className="MakeReadyBoard__timeline-section">
                <div className="MakeReadyBoard__calendar">
                  <Calendar day={day} handleDayChange={this.handleDayChange} range={range} onAction={this.handleAction} updateRange={this.updateRange} updateSort={this.updateSort}  
                   isPermissionAvailable={this.isPermissionAvailable} />
                </div>
              </div>
            )}
            <Pagination currentPage={this.state.page} totalRecords={count} pageLimit={this.state.pageLimit} updatePage={this.updatePage} />
          </MrbContextProvider>
        </Suspense>
        { loading &&
          <Spin/>
        }
      </div>
    );
  }
}

MakeReadyBoard.propTypes = {
  configTheme: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  demoData: PropTypes.array,
  onAction: PropTypes.func.isRequired
};

window.MakeReadyBoard = MakeReadyBoard;
export default MakeReadyBoard;
